import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getHelpCenterTopBarSplitFlag } from 'state/selectors/help-center';
import SectionViewRenderer from './section-view-renderer';

const selector = createSelector(getHelpCenterTopBarSplitFlag, (hasTopBarBeenSplit) => ({
	hasTopBarBeenSplit,
}));

export default connect(selector, {})(SectionViewRenderer);
